(function () {
  'use strict';
  function initStickyBuy(container) {
    container.querySelectorAll('[data-agp-sticky-buy]').forEach(function (bar) {
      if (bar.agpCleanup) return;
      var form = document.getElementById(bar.dataset.productForm);
      var original = form && form.querySelector('[name="add"]');
      if (!original) return;
      var section = form.closest('[data-section-type="product-template"]');
      var price = section && section.querySelector('.product-single__price');
      var button = bar.querySelector('.agp-sticky-buy__button');
      var stickyPrice = bar.querySelector('.agp-sticky-buy__price');
      var selection = bar.querySelector('.agp-sticky-buy__selection');
      var reviewed = !form.querySelector('[data-index]');
      var chooseOptions = false;
      var frame = 0;
      function sync() {
        frame = 0;
        var viewHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
        var deposit = section && section.querySelector('[data-agp-deposit]:not([hidden]), [data-agp-backorder-help]:not([hidden])');
        var rect = (deposit || original).getBoundingClientRect();
        var inView = rect.bottom > 0 && rect.top < viewHeight;
        if (inView) reviewed = true;
        var focused = document.activeElement;
        var editing = focused && /^(INPUT|TEXTAREA|SELECT)$/.test(focused.tagName) && focused.type !== 'radio' && focused.type !== 'checkbox';
        var drawerOpen = document.documentElement.classList.contains('js-drawer-open') || document.body.classList.contains('js-drawer-open');
        var visible = window.innerWidth <= 768 && !inView && !editing && !drawerOpen;
        bar.hidden = !visible;
        bar.classList.toggle('is-visible', visible);
        button.disabled = !deposit && (original.disabled || original.classList.contains('btn--loading') || original.getAttribute('aria-busy') === 'true');
        chooseOptions = !reviewed && !button.disabled;
        var enquiry = deposit && deposit.hasAttribute('data-agp-backorder-help');
        button.textContent = deposit ? (enquiry ? 'Ask about backorder' : 'Backorder with 10% deposit') : (chooseOptions ? bar.dataset.chooseOptions : (original.querySelector('.btn__text') || original).textContent.trim());
        if (price && stickyPrice) stickyPrice.textContent = deposit ? (enquiry ? 'Contact us for timing' : '10% deposit at checkout') : price.textContent.trim();
        var values = [];
        form.querySelectorAll('[data-index]').forEach(function (input) {
          if (input.type !== 'radio' || input.checked) values.push(input.value);
        });
        var quantity = form.querySelector('[name="quantity"]');
        if (quantity && Number(quantity.value) > 1) values.push('Qty ' + quantity.value);
        selection.textContent = values.join(' · ');
        selection.hidden = !values.length;
      }
      function schedule() {
        if (!frame) frame = window.requestAnimationFrame(sync);
      }
      function changed() { reviewed = true; schedule(); }
      function buy() {
        var deposit = section && section.querySelector('[data-agp-deposit]:not([hidden]), [data-agp-backorder-help]:not([hidden])');
        if (deposit) {
          deposit.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          deposit.querySelector('[name="quantity"], a').focus({ preventScroll: true });
          return;
        }
        if (original.disabled) return;
        if (chooseOptions) {
          var target = form.querySelector('.radio-wrapper, [name="quantity"]') || original;
          target.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          var input = target.querySelector('input:checked, select') || original;
          input.focus({ preventScroll: true });
          return;
        }
        // Preserve the original form validation and Shopify cart behavior.
        original.click();
      }
      button.addEventListener('click', buy);
      form.addEventListener('change', changed);
      form.addEventListener('input', schedule);
      if (section) section.addEventListener('agp:deposit-change', schedule);
      document.addEventListener('focusin', schedule);
      document.addEventListener('focusout', schedule);
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule);
      var observer = new MutationObserver(schedule);
      observer.observe(original, { attributes: true, childList: true, subtree: true, characterData: true });
      if (price) observer.observe(price, { childList: true, subtree: true, characterData: true });
      observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      bar.agpCleanup = function () {
        observer.disconnect();
        window.cancelAnimationFrame(frame);
        button.removeEventListener('click', buy);
        form.removeEventListener('change', changed);
        form.removeEventListener('input', schedule);
        if (section) section.removeEventListener('agp:deposit-change', schedule);
        document.removeEventListener('focusin', schedule);
        document.removeEventListener('focusout', schedule);
        window.removeEventListener('scroll', schedule);
        window.removeEventListener('resize', schedule);
        if (window.visualViewport) window.visualViewport.removeEventListener('resize', schedule);
        delete bar.agpCleanup;
      };
      sync();
    });
  }
  function ready() { initStickyBuy(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
  document.addEventListener('shopify:section:load', function (event) { initStickyBuy(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-agp-sticky-buy]').forEach(function (bar) { if (bar.agpCleanup) bar.agpCleanup(); });
  });
}());
